import { LoadedContent } from "src/components/common/loading/loadedContent";
import { InputModalContentLayout } from "../common/InputModalContentLayout";

import { useTenantData } from "contexts/tenant";
import { useMaterialOverridesDependencies } from "./dependencies";
import { MaterialOverridesTable } from "components/materialChemistry/MaterialOverridesTable";
import { AddMaterialChemistryForm } from "components/materialChemistry/AddMaterialChemistryForm";
import { useHandleTableMutations } from "./useHandleTableMutations";

export const MaterialOverridesEditor = () => {
  const { impurity_plot_type } = useTenantData();
  const showScale = impurity_plot_type === "box";
  const { handleAddNewItem, handleUpdateItem, handleDeleteItem } =
    useHandleTableMutations();
  return (
    <LoadedContent data={useMaterialOverridesDependencies()} enableFullHeight>
      {({
        materials,
        chemicalElements,
        materialChemistry,
        materialChemistryOverrides,
      }) => {
        return (
          <InputModalContentLayout
            leftPanel={
              <MaterialOverridesTable
                onUpdate={handleUpdateItem}
                onRevert={handleDeleteItem}
                materials={materials}
                chemicalElements={chemicalElements}
                materialChemistry={materialChemistry}
                materialChemistryOverrides={materialChemistryOverrides}
                showScale={showScale}
              />
            }
            rightPanel={
              <AddMaterialChemistryForm
                materials={materials}
                chemicalElements={chemicalElements}
                materialChemistry={materialChemistry}
                materialChemistryOverrides={materialChemistryOverrides}
                onAdd={handleAddNewItem}
                showScale={showScale}
              />
            }
            bottomPanel={null}
            removeLeftPanelOutline
          />
        );
      }}
    </LoadedContent>
  );
};
